import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources, DEFAULT_LANGUAGE, NAMESPACES, DEFAULT_NAMESPACE } from '@tradermind/shared/i18n';

// Web 端使用静态资源（与 Mobile 端保持一致，简化部署）
// 如需懒加载，可改用 i18next-http-backend

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    ns: NAMESPACES,
    defaultNS: DEFAULT_NAMESPACE,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
